<template>
  <div>
    <DefaultLayout>
      <template #mainHeader>
        <InhousePortalHeader />
      </template>
      <template #page="{ layoutParams }">
        <TableLayout
          :layoutParams="layoutParams"
          :hideFooter="searchParams.pageCount >= searchParams.total_item"
        >
          <template #tableHeader="{ updateHeader }">
            <TableHeader
              ref="tableHeader"
              :pageTitle="setPageTitle"
              :multiRemoveStatus="disableRemoveBtn"
              :updateHeader="updateHeader"
              addButtonTitle="新規作成"
              :endUseSite="endUseSite"
              :isSearch="false"
              :isEndUseSite="true"
              :disableBtnAdd="disableBtnAdd"
              @openRemoveDialog="openRemoveDialog"
              @openItemForm="openNewItemForm"
              @openEndUseDialog="openEndUseDialog"
            >
            </TableHeader>
            <SearchFormWrapper>
              <InputText
                class="search width-large"
                placeholder="現場名"
                name="word"
                :editable="true"
                :values="searchInputs"
                @onInput="onChangeSearchInputs"
              />
              <SwitchInput
                class="search"
                name="end_use_flg"
                label="終了した現場のみ表示"
                :editable="true"
                :values="searchInputs"
                @onInput="onChangeSearchInputs"
              />
              <v-btn class="search" color="primary" @click="onSearch">
                検索
              </v-btn>
            </SearchFormWrapper>
            <TableSortWrapper>
              <TableSort
                :values="searchParams"
                :sort_items="SORT_ITEMS"
                sort_item_text="name"
                sort_item_value="id"
                :page_counts_options="PAGE_COUNT_OPTIONS"
                :sort_order_options="SORT_ORDERS"
                :total_item="searchParams.total_item"
                @onInput="onChangeSortParams"
              />
            </TableSortWrapper>
          </template>
          <template #tableBody="{ tableHeight }">
            <v-data-table
              v-if="isNestTable"
              show-expand
              single-expand
              item-key="company_id"
              :headers="COMPANY_LABEL"
              :items="items"
              :items-per-page="searchParams.pageCount"
              :height="tableHeight"
              :expanded.sync="expanded"
              hide-default-footer
              disable-sort
              sort-by="updatedAt"
              noDataText="データがありません。"
            >
              <template
                v-slot:item.data-table-expand="{ item, expand, isExpanded }"
              >
                <v-btn
                  v-if="item.childrens && item.childrens.length"
                  icon
                  @click="expand(!isExpanded)"
                >
                  <v-icon>{{ isExpanded ? "mdi-minus" : "mdi-plus" }}</v-icon>
                </v-btn>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-data-table
                    :headers="TABLE_LABELS"
                    :items="item.childrens || []"
                    :height="tableHeight - 200"
                    item-key="field_id"
                    v-model="selectedItems"
                    show-select
                    dense
                    hide-default-footer
                    hide-default-header
                    :items-per-page="-1"
                    @dblclick:row="($event, { item }) => openItemForm(item)"
                  >
                    <template v-slot:[`item.address`]="{ item }">
                      <div>
                        {{ getDetailAddress(item) }}
                      </div>
                    </template>
                    <template v-slot:[`item.dowload_qr`]="{ item }">
                      <v-btn
                        v-if="!item.end_use_flg"
                        class="float-right"
                        color="primary"
                        @click.stop="dowloadQRCode(item.field_id)"
                      >
                        QRコード
                      </v-btn>
                      <v-btn
                        v-if="item.end_use_flg"
                        class="float-right"
                        color="secondary"
                        @click.stop="gotoAchievements(item.field_id)"
                      >
                        実績確認
                      </v-btn>
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
            <v-data-table
              v-else
              item-key="field_id"
              :headers="TABLE_LABELS"
              :items="items"
              :items-per-page="searchParams.pageCount"
              :height="tableHeight"
              v-model="selectedItems"
              show-select
              hide-default-footer
              disable-sort
              sort-by="updatedAt"
              noDataText="データがありません。"
              @dblclick:row="($event, { item }) => openItemForm(item)"
            >
              <template v-slot:[`item.address`]="{ item }">
                <div>
                  {{ getDetailAddress(item) }}
                </div>
              </template>
              <template v-slot:[`item.dowload_qr`]="{ item }">
                <v-btn
                  v-if="!item.end_use_flg"
                  class="float-right"
                  color="primary"
                  @click.stop="dowloadQRCode(item.field_id)"
                >
                  QRコード
                </v-btn>
                <v-btn
                  v-if="item.end_use_flg"
                  class="float-right"
                  color="secondary"
                  @click.stop="gotoAchievements(item.field_id)"
                >
                  実績確認
                </v-btn>
              </template>
            </v-data-table>
          </template>
          <template #tableFooter>
            <Pagination
              :current="searchParams.currentPage"
              :total="searchParams.totalPage"
              @pageUpdate="pageUpdate"
            />
          </template>
        </TableLayout>
      </template>
    </DefaultLayout>

    <Popup :dialog="popups.isShowItemForm">
      <SitesForm
        :item="editedItem"
        :isNewItem="isNewItem"
        @formUpdate="formUpdate"
        @submit="submitForm"
        @cancel="closeItemForm"
        :key="isResetForm"
        ref="SitesForm"
        :keyButton="keyButton"
      />
    </Popup>
    <Popup width="500px" :dialog="popups.isShowRemoveDialog">
      <ConfirmDialog
        @close="closeRemoveDialog()"
        @yes="removeItems()"
        :isDelete="true"
        :isSiteDetails="true"
        title="選択項目の削除"
        text="以下を削除してもよろしいですか？"
        :items="selectedItems"
      />
    </Popup>
    <Popup width="500px" :dialog="popups.isShowEndUseDialog">
      <ConfirmDialog
        @close="popups.isShowEndUseDialog = false"
        @yes="callEndUseSite()"
        :isEndUse="true"
        :isSiteDetails="true"
        :isCenter="false"
        title="現場終了"
        text="現場を終了しようとしています。
        実行しますか？"
        :items="selectedItems"
      />
    </Popup>
    <Popup width="500px" :dialog="popups.isShowCancelEndUseDialog">
      <ConfirmDialog
        @close="popups.isShowCancelEndUseDialog = false"
        @yes="cancelEndUseSite()"
        :isUnlock="true"
        :isSiteDetails="true"
        :isCenter="false"
        title="現場再開"
        text="下記の現場を再開しようとしています。
        実行しますか？"
        :items="selectedItems"
      />
    </Popup>
    <Loader :isLoading="isLoading"></Loader>
  </div>
</template>
<script>
import { Store } from "@/store/Store.js";
import _ from "lodash";
import { getFullCompanyName } from "@/utils/common";
import {
  TABLES_PER_PAGE,
  TABLE_SORT_ORDERS,
  COMPANY_TYPE,
  USER_ROLE,
} from "@/constants/COMMON";
import {
  SITE_TABLE_LABELS,
  SITE_TABLE_COMPANY,
  SITE_SORT_ITEMS,
  SITE_INITIAL_ITEM,
  SITE_TITLE,
} from "@/constants/SITES";
import {
  HEADER_MENU_ITEMS_INHOUSE,
  HEADER_MENU_END_USE_FIELD,
} from "@/constants/GLOBALHEADER";

// Components
import DefaultLayout from "@/components/layout/DefaultLayout";
import TableLayout from "@/components/layout/TableLayout";
import TableHeader from "@/components/forms/elements/TableHeader";
import Pagination from "@/components/forms/elements/Pagination";
import SearchFormWrapper from "@/components/forms/elements/SearchFormWrapper";
import TableSortWrapper from "@/components/forms/elements/TableSortWrapper";
import TableSort from "@/components/forms/elements/TableSort";
import Popup from "@/components/common/Popup";
import Loader from "@/components/forms/elements/Loader";
import InhousePortalHeader from "@/components/globalHeader/InhousePortalHeader";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import SitesForm from "@/components/forms/sites/SitesForm";
import InputText from "@/components/forms/elements/InputText";
import SwitchInput from "@/components/forms/elements/SwitchInput";
import Label from "@/components/forms/elements/Label";

// 定数
const PAGE_TITLE = SITE_TITLE;
const PAGE_COUNT = 25;
const PAGE_COUNT_OPTIONS = TABLES_PER_PAGE;
const SORT_ORDERS = TABLE_SORT_ORDERS;
const STORE = "Sites";
const TABLE_LABELS = SITE_TABLE_LABELS;
const COMPANY_LABEL = SITE_TABLE_COMPANY;
const SORT_ITEMS = SITE_SORT_ITEMS;
const INITIAL_ITEM = SITE_INITIAL_ITEM;
const DOWNLOAD_QR_CODE_URL = `${process.env.VUE_APP_API_BASE_URL}/reports/exportFieldQRCode`;

export default {
  head: {
    title() {
      return { inner: "", separator: " ", complement: PAGE_TITLE };
    },
  },
  components: {
    DefaultLayout,
    TableLayout,
    TableHeader,
    Pagination,
    SearchFormWrapper,
    TableSortWrapper,
    TableSort,
    InhousePortalHeader,
    Popup,
    Loader,
    ConfirmDialog,
    SitesForm,
    InputText,
    SwitchInput,
    Label,
  },
  data() {
    return {
      PAGE_TITLE,
      TABLE_LABELS,
      COMPANY_LABEL,
      SORT_ITEMS,
      SORT_ORDERS,
      PAGE_COUNT_OPTIONS,
      items: [],
      expanded: [],
      selectedItems: [],
      isResetForm: false,
      editedItem: {},
      isNewItem: false,
      endUseSite: "現場終了",
      searchParams: {
        word: "",
        pageCount: PAGE_COUNT,
        currentPage: 1,
        totalPage: 1,
        sort: null,
        asc: true,
      },
      popups: {
        isShowItemForm: false,
        isShowRemoveDialog: false,
        isShowEndUseDialog: false,
        isShowCancelEndUseDialog: false,
      },
      searchInputs: {
        word: "",
        end_use_flg: null,
      },
      keyButton: false,
      isLoading: false,
    };
  },

  async mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    Store.dispatch("GlobalHeader/setInHouseMenu", {
      menuId: HEADER_MENU_ITEMS_INHOUSE.SITES.id,
    });
    Store.dispatch("GlobalHeader/setSite", {
      field_id: null,
    });
    this.$watch(
      () => this.companyType,
      (type) => {
        if (type == undefined && type == null) return;
        this.getItems();
      },
      {
        immediate: true,
        deep: true,
      }
    );
    this.$watch(
      () => [
        Store.getters[`${STORE}/getData`],
        Store.getters[`${STORE}/getPagination`],
      ],
      (data) => {
        let rawItems;
        if (this.searchInputs.end_use_flg != 1) {
          rawItems = data[0].filter((item) => item.end_use_flg != 1);
        } else {
          rawItems = data[0];
        }
        this.items = rawItems;
        let searchParams = { ...this.searchParams };
        searchParams.totalPage = data[1].total;
        searchParams.currentPage = data[1].current;
        searchParams.total_item = data[1].total_item;
        this.searchParams = searchParams;
      },
      {
        immidiate: true,
        deep: true,
      }
    );
    this.$watch(
      () => [Store.getters["File/getData"]],
      (data) => {
        if (data && data[0]) {
          const url = window.URL.createObjectURL(new Blob([data[0]]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Tnk_Field_Qr.pdf");
          document.body.appendChild(link);
          link.click();
          Store.dispatch("File/clearData");
        }
      },
      {
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    isNestTable() {
      if (
        this.companyType === COMPANY_TYPE.ADMIN ||
        this.companyType === COMPANY_TYPE.PARTNER
      ) {
        return true;
      } else {
        return false;
      }
    },
    setPageTitle() {
      const companyName = getFullCompanyName(
        this.loginUser.corporate_type,
        this.loginUser.company_name
      );
      if (
        this.companyType === COMPANY_TYPE.ADMIN ||
        this.companyType === COMPANY_TYPE.PARTNER
      ) {
        return PAGE_TITLE;
      } else {
        return [this.loginUser.corporate_number, companyName, PAGE_TITLE].join(
          "\u00A0\u00A0\u00A0\u00A0"
        );
      }
    },
    disableRemoveBtn() {
      return (
        this.selectedItems.length === 0 ||
        (this.companyType === COMPANY_TYPE.OWNER &&
          this.loginUser.role != USER_ROLE.MASTER) ||
        this.companyType === COMPANY_TYPE.PARTNER ||
        this.companyType === COMPANY_TYPE.RENTAL
      );
    },
    apiParams() {
      return {
        name: this.searchParams.word,
        end_use_flg: this.searchParams.end_use_flg == 1 ? 1 : null,
        group_required: this.isNestTable ? 1 : null,
        sort_value: this.searchParams.sort,
        sort_by: this.searchParams.asc ? 1 : 0,
        page_number: this.searchParams.currentPage,
        page_size: this.searchParams.pageCount,
      };
    },
    disableBtnAdd() {
      if (
        this.companyType === COMPANY_TYPE.ADMIN ||
        this.loginUser.role === USER_ROLE.MASTER
      )
        return false;
      return true;
    },
  },
  methods: {
    getDetailAddress(item) {
      return `${item.prefecture} ${item.city} ${item.address}`;
    },
    pageUpdate(n) {
      let searchParams = { ...this.searchParams };
      searchParams.currentPage = n;
      this.searchParams = searchParams;
      this.getItems();
    },
    onSearch() {
      this.searchParams = { ...this.searchParams, ...this.searchInputs };
      this.searchParams["currentPage"] = 1;
      this.$nextTick(() => {
        this.selectedItems = [];
      });
      this.getItems();
    },
    onChangeSearchInputs({ name, value }) {
      let searchInputs = { ...this.searchInputs };
      searchInputs[name] = value;
      this.searchInputs = searchInputs;
    },
    onChangeSortParams({ name, value }) {
      let searchParams = { ...this.searchParams };
      searchParams[name] = value;
      this.searchParams = searchParams;
      this.getItems();
    },
    async openItemForm(item) {
      const siteInfo = await Store.dispatch(
        `${STORE}/getSitesDetail`,
        item.field_id
      );
      if (!siteInfo.hasError) {
        this.editedItem = { ...siteInfo.data.contents.entries };
        this.isNewItem = false;
        this.popups.isShowItemForm = true;
      }
    },
    async openNewItemForm() {
      this.editedItem = { ...INITIAL_ITEM };
      this.isNewItem = true;
      this.popups.isShowItemForm = true;
    },
    closeItemForm() {
      this.popups.isShowItemForm = false;
      this.$nextTick(() => {
        this.editedItem = { ...INITIAL_ITEM };
      });
    },
    openRemoveDialog() {
      this.popups.isShowRemoveDialog = true;
    },
    closeRemoveDialog() {
      this.popups.isShowRemoveDialog = false;
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    formUpdate(params) {
      this.editedItem = { ...params };
    },
    async getItems() {
      this.isLoading = true;
      if (this.apiParams.end_use_flg != 1) {
        this.endUseSite = "現場終了";
      } else {
        this.endUseSite = "終了取消";
      }
      await Store.dispatch(`${STORE}/get`, { params: this.apiParams });
      this.isLoading = false;
    },
    async removeItems() {
      const field_ids = this.selectedItems.map((items) => items.field_id);
      const result = await Store.dispatch(`${STORE}/delete`, { field_ids });
      if (!result.hasError) {
        this.getItems();
        Store.dispatch("Toast/show", {
          status: 200,
          message: "削除しました",
        });
      }
      this.closeRemoveDialog();
    },
    async submitForm() {
      const hasId = "id" in this.editedItem;
      const result = await Store.dispatch(
        hasId ? `${STORE}/update` : `${STORE}/add`,
        this.editedItem
      );
      if (result.hasError) {
        this.keyButton = !this.keyButton;
        return;
      }
      if (this.editedItem.contact_user_id) {
        let user = await Store.dispatch(
          "Users/getUserDetail",
          this.editedItem.contact_user_id
        );
        let apiParams = {
          ...user.data.contents.entries,
          tel: this.editedItem.contact_phone,
        };
        await Store.dispatch("Users/update", apiParams);
      }
      if (hasId) {
        Store.dispatch("Toast/show", {
          status: 200,
          message: "更新しました",
        });
        const resultDetail = await Store.dispatch(
          `${STORE}/getSitesDetail`,
          this.editedItem.id
        );
        this.editedItem = _.cloneDeep(resultDetail.data.contents.entries);
        this.isResetForm = !this.isResetForm;
      } else {
        this.closeItemForm();
        Store.dispatch("Toast/show", {
          status: 200,
          message: "登録しました",
        });
      }
      this.getItems();
    },
    async dowloadQRCode(field_id) {
      let params = { field_id };

      const configParams = {
        url: DOWNLOAD_QR_CODE_URL,
        params: params,
      };
      await Store.dispatch("File/download", configParams);
    },
    async gotoAchievements(field_id) {
      await Store.dispatch("GlobalHeader/setSite", {
        field_id: field_id,
      });
      this.$router
        .push(HEADER_MENU_END_USE_FIELD.INSPECTOR_FIELD.path)
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
    openEndUseDialog() {
      if (this.apiParams.end_use_flg == 1) {
        this.popups.isShowCancelEndUseDialog = true;
      } else {
        this.popups.isShowEndUseDialog = true;
      }
    },
    async callEndUseSite() {
      const field_ids = this.selectedItems.map((items) => items.field_id);

      field_ids.forEach(async (field_id) => {
        const siteInfo = await Store.dispatch(
          `${STORE}/getSitesDetail`,
          field_id
        );
        if (!siteInfo.hasError) {
          let details = { ...siteInfo.data.contents.entries };
          details["end_use_flg"] = 1;
          const result = await Store.dispatch(`${STORE}/update`, details);
          if (!result.hasError) {
            this.getItems();
            Store.dispatch("Toast/show", {
              status: 200,
              message: "現場を終了しました",
            });
            this.$nextTick(() => {
              this.selectedItems = [];
            });
          }
        }
      });
      this.popups.isShowEndUseDialog = false;
    },
    async cancelEndUseSite() {
      const field_ids = this.selectedItems.map((items) => items.field_id);

      field_ids.forEach(async (field_id) => {
        const siteInfo = await Store.dispatch(
          `${STORE}/getSitesDetail`,
          field_id
        );
        if (!siteInfo.hasError) {
          let details = { ...siteInfo.data.contents.entries };
          details["end_use_flg"] = null;
          const result = await Store.dispatch(`${STORE}/update`, details);
          if (!result.hasError) {
            this.getItems();
            Store.dispatch("Toast/show", {
              status: 200,
              message: "現場を再開しました",
            });
            this.$nextTick(() => {
              this.selectedItems = [];
            });
          }
        }
      });
      this.popups.isShowCancelEndUseDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep table {
  table-layout: fixed !important;
}
</style>
